/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24/ContainerHome24';
import CustomEmblaCarouselHome24 from '../../organisms/CustomEmblaCarouselHome24';
import Styles from './Home24Services.css';
import { isMobile } from '@/utils/browser';

function Home24Services() {
  return (
    <section id="santander-servicos">
      <ContainerHome24>
        <h2 className="text-headline">Serviços para você</h2>
      </ContainerHome24>

      <ContainerHome24>
        <div>
          <CustomEmblaCarouselHome24
            loop
            enableBullets
            enableMobileArrows
            options={{ slidesToScroll: isMobile() ? 2 : 3 }}
            detectBulletCount
          >
            {({ className }) => (
              <>
                <div className={`slide ${className}`}>
                  <a
                    className="service-card"
                    href="banco-do-auto.html"
                    id="servicos-financiamento-de-veiculos"
                  >
                    {/* <div className="flag-destaque">
                    <img
                      src="static/amp/shared/assets/mega_feirao_flag.svg"
                      alt="Flag Mega Feirão"
                    />
                  </div> */}
                    <img
                      src="static/amp/shared/assets/ic_car.svg"
                      alt="Ícone de automóvel"
                      layout="fixed"
                      height="32"
                      width="40"
                    />

                    <h3>
                      Financiamento <br />
                      de veículos
                    </h3>
                  </a>
                </div>
                <div className={`slide ${className}`}>
                  <a
                    className="service-card"
                    href="boleto.html"
                    id="servicos-segunda-via-de-boletos"
                  >
                    <img
                      src="static/amp/shared/assets/ic_barcode.svg"
                      alt="Ícone de código de barras"
                      layout="fixed"
                      height="40"
                      width="40"
                    />
                    <h3>
                      2ª via <br />
                      de boletos
                    </h3>
                  </a>
                </div>
                <div className={`slide ${className}`}>
                  <a
                    className="service-card"
                    href="emprestimo-garantia-carro.html"
                    id="servicos-emprestimo-com-garantia"
                  >
                    <img
                      src="static/amp/shared/assets/ic_bank_loan.svg"
                      alt="Ícone de empréstimo"
                      layout="fixed"
                      height="40"
                      width="40"
                    />
                    <h3>
                      Empréstimo <br />
                      com Garantia
                    </h3>
                  </a>
                </div>
                <div className={`slide ${className}`}>
                  <a
                    className="service-card"
                    href="financiamento-de-motos.html"
                    id="servicos-financiamento-moto"
                  >
                    <img
                      src="static/amp/shared/assets/ic_motorcycle.svg"
                      alt="Ícone de auto negócio"
                      layout="fixed"
                      height="40"
                      width="40"
                    />
                    <h3>
                      Financiamento <br /> de motos
                    </h3>
                  </a>
                </div>
                <div className={`slide ${className}`}>
                  <a
                    className="service-card"
                    href="energia-solar-fotovoltaica.html"
                    id="servicos-parcele-com-mais-vezes"
                  >
                    {/* <div className="tag-destaque">Taxa promocional</div> */}
                    <img
                      src="static/amp/shared/assets/ic_housing.svg"
                      alt="Ícone de casa"
                      layout="fixed"
                      height="40"
                      width="40"
                    />
                    <h3>
                      Energia
                      <br /> Solar
                    </h3>
                  </a>
                </div>
                <div className={`slide ${className}`}>
                  <a
                    className="service-card"
                    href="https://santanderfinanciamentos.com.br/portalcliente/login"
                    target="_blank"
                    rel="noopener"
                    id="servicos-renegociacao-de-dividas"
                  >
                    <img
                      src="static/amp/shared/assets/ic_payment.svg"
                      alt="Ícone de pagamento"
                      layout="fixed"
                      height="40"
                      width="40"
                    />
                    <h3>
                      Renegociação <br />
                      de dívidas
                    </h3>
                  </a>
                </div>
                <div className={`slide ${className}`}>
                  <a
                    className="service-card"
                    href="financiamento-entre-particulares.html"
                    id="servicos-auto-negocio"
                  >
                    <img
                      src="static/amp/shared/assets/ic-auto-negocio.svg"
                      alt="Ícone de auto negócio"
                      layout="fixed"
                      height="40"
                      width="40"
                    />
                    <h3>
                      Financiar <br />
                      veículo particular
                    </h3>
                  </a>
                </div>

                {/* <div className={`slide ${className}`}>
                  <a
                    className="service-card"
                    href="blog/declaracao-de-imposto-de-renda.html"
                    id="servicos-segunda-via-de-boletos"
                  >
                    <img
                      src="static/amp/shared/assets/ic_copy_2.svg"
                      alt="Ícone de código de barras"
                      layout="fixed"
                      height="40"
                      width="40"
                    />
                    <h3>
                      Imposto <br />
                      de renda
                    </h3>
                  </a>
                </div> */}

                {/* <div className={`slide ${className}`}>
                <a
                  className="service-card"
                  href="https://santanderfinanciamentos.com.br/portalcliente/login?int_source=portalSF&int_medium=home:card&int_campaign=copia-de-contrato"
                  target="_blank"
                  rel="noopener"
                  id="servicos-copia-de-contrato"
                >
                  <img
                    src="static/amp/shared/assets/ic_copy.svg"
                    alt="Ícone de cópia"
                    layout="fixed"
                    height="40"
                    width="32"
                  />
                  <h3>
                    Cópia de <br />
                    contrato
                  </h3>
                </a>
              </div> */}
              </>
            )}
          </CustomEmblaCarouselHome24>
        </div>
      </ContainerHome24>

      <style jsx>{Styles}</style>
    </section>
  );
}

export default Home24Services;
